<template>
  <div class="plane-home-page">
    <van-nav-bar
      :class="{ isiOSX: isiOSX }"
      title="机票出行"
      right-text="常见问题"
      left-arrow
      @click-left="goBack"
      @click-right="commonProbem"
    />
    <van-row class="content">
      <van-col span="24" class="banner">
        <img
          v-if="banner"
          class="banner"
          :src="banner.img_url"
          @click="bannerAdv()"
        />
      </van-col>
      <van-col class="Msg" span="24">
        <div class="box">
          <p class="area">
            <span class="left" @click="selectDeparture()">{{
              departure.city
            }}</span>
            <img @click="changePlace" src="../../assets/plane/return@2x.png" />
            <span class="right" @click="selectDestination()">{{
              destination.city
            }}</span>
          </p>
          <p class="time" @click="enterDate">
            {{ departureDate.date }}
            <span>{{ departureDate.text }}</span>
            <img src="../../assets/plane/more@2x.png" />
          </p>
          <p class="space">
            <span @click="seleceSpace">{{
              cabin.title == false ? cabin_choose : cabin.title
            }}</span>
            <span class="right r_r">
              <img
                @click="changeBy"
                v-if="!baby"
                src="../../assets/plane/noselect@2x.png"
              />
              <img
                @click="changeBy"
                v-if="baby"
                src="../../assets/plane/delected@2x.png"
              />
              <span>带婴儿</span>
              <span>小于2岁</span>
            </span>
            <span class="right r_h">
              <img
                @click="changeCh"
                v-if="!child"
                src="../../assets/plane/noselect@2x.png"
              />
              <img
                @click="changeCh"
                v-if="child"
                src="../../assets/plane/delected@2x.png"
              />
              <span>带儿童</span>
              <span>2-12岁</span>
            </span>
          </p>
          <p class="child">
            <span v-if="child || baby" @click="childPopup">
              儿童婴儿预定说明
              <img src="../../assets/plane/notice@2x.png" />
            </span>
          </p>
          <van-button
            :disabled="cabin.title == false"
            size="large"
            @click="search"
            >搜索</van-button
          >
        </div>
      </van-col>
    </van-row>
    <van-tabbar>
      <van-tabbar-item @click="orderList()">
        <span>机票订单</span>
        <img slot="icon" src="../../assets/plane/order@2x.png" />
      </van-tabbar-item>
      <van-tabbar-item @click="collection()">
        <span>航班收藏</span>
        <img slot="icon" src="../../assets/plane/dislike@2x.png" />
      </van-tabbar-item>
    </van-tabbar>
    <!--儿童预定说明-->
    <van-popup v-model="childPop" class="reserve">
      <img
        class="close"
        @click="childPopup"
        src="../../assets/plane/close@2x.png"
      />
      <div class="explain-child">
        <div class="explain-box">
          <p class="title">儿童婴儿预定须知</p>
          <div class="explain-con top-con">
            <p>儿童购票说明（按航班起飞当日的实际年龄计算）</p>
            <p>1. 2周岁（含）-12周岁（不含）可购买儿童票</p>
            <p>
              2. 儿童购票可使用身份证、户口簿、护照等，具体以航班和舱位要求为准
            </p>
            <p>3. 儿童乘机须有成人陪同，1名成人最多携带2名儿童</p>
            <p>4. 儿童单独乘机请联系航空公司购票</p>
          </div>
          <div class="explain-con">
            <p>婴儿票购买说明（按航班起飞当日的实际年龄计算）</p>
            <p>
              1.
              足月婴儿出生满14天且未满2周岁可购买婴儿票，早产婴儿出生满90天且未满2周岁可购买婴儿票
            </p>
            <p>
              2.
              婴儿购票可使用身份证、户口簿、护照、出生证明等，具体以航班和舱位要求为准
            </p>
            <p>3. 婴儿乘机须有成人陪同，1名成人最多携带1名婴儿</p>
            <p>4.婴儿不单独占座</p>
          </div>
        </div>
      </div>
    </van-popup>
    <!--选择舱位弾层-->
    <van-popup v-model="spacePop" position="bottom" :overlay="true">
      <van-row>
        <van-col class="title" span="24">选择舱位</van-col>
        <van-col
          class="list"
          span="24"
          v-for="(item, index) in lists"
          :key="index"
        >
          <div @click="change(item, index)">
            <span>{{ item.title }}</span>
            <img v-if="i === index" src="../../assets/plane/delected@2x.png" />
            <img v-else src="../../assets/plane/noselect@2x.png" />
          </div>
        </van-col>
        <van-col class="cancel" span="24">
          <van-button size="large" @click="close">关闭</van-button>
        </van-col>
      </van-row>
    </van-popup>
    <!-- <van-popup class="tipMSG" v-model="show">
      <div class="box">
        <p class="title">
          <img src="../../assets/plane/notice_popup@2x.png" alt="" />
        </p>
        <p class="message">
          即日起，交易完成的机票订单<span>支持开具购买机票的增值税发票</span>，便于您报销时使用。
        </p>
        <span class="btn" @click="confirm()">我知道了</span>
        <p class="tip">
          <img
            v-if="isChecked"
            @click="isChecked = false"
            src="../../assets/plane/delected@2x.png"
          /><img
            v-else
            @click="isChecked = true"
            src="../../assets/plane/noselect@2x.png"
          />下次不再弹出
        </p>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import { format } from "path";
import defaultImg from "@/assets/plane/banner@2x.png";
export default {
  data() {
    return {
      spacePop: false,
      cabin_choose: "选择舱位",
      child: false,
      baby: false,
      childPop: false,
      departure: { city: "杭州", character: "HGH" },
      placeSwitch: "",
      destination: { city: "重庆", character: "CKG" },
      child_quantity: "0",
      baby_quantity: "0",
      lists: [
        {
          title: "不限",
          id: 0,
        },
        {
          title: "经济舱",
          id: 1,
        },
        {
          title: "商务舱",
          id: 2,
        },
        {
          title: "头等舱",
          id: 3,
        },
      ],
      departureDate: {},
      selected: "",
      tomorrow: "",
      i: "",
      cabin: {
        title: "选择舱位",
        id: 0,
      },
      isiOSX: false,
      banner: { images: defaultImg },
      // show: false,
      // isChecked: false,
    };
  },
  created() {
    // if (
    //   sessionStorage.getItem("isChecked") !== "true" &&
    //   localStorage.getItem("isChecked") !== "true"
    // ) {
    //   this.show = true;
    // }
    this.isiOSX = this.isIphoneX();
    this.getPath();
    this.getBanner();
  },
  watch: {
    $route: "getPath",
  },
  methods: {
    // confirm() {
    //   this.show = false;
    //   if (this.isChecked) {
    //     localStorage.setItem("isChecked", true);
    //   } else {
    //     sessionStorage.setItem("isChecked", true);
    //   }
    // },
    getPath() {
      this.$api.setToken(this.$route.query.token);
      if (
        this.$route.query.city1 != "" &&
        this.$route.query.city1 != null &&
        this.$route.query.city1 != undefined
      ) {
        //出发城市
        this.departure.city = this.$route.query.city1;
        this.departure.character = this.$route.query.character1;
        sessionStorage.setItem("departureInfo", JSON.stringify(this.departure));
      }
      if (
        this.$route.query.city2 != "" &&
        this.$route.query.city2 != null &&
        this.$route.query.city2 != undefined
      ) {
        this.destination.city = this.$route.query.city2;
        this.destination.character = this.$route.query.character2;
        sessionStorage.setItem(
          "destinationInfo",
          JSON.stringify(this.destination)
        );
      }
    },
    getBanner() {
      this.$api
        .post("/adspace/index/get/ad/list", { labels: ["air_index"] })
        .then((res) => {
          if (res.air_index[0]) {
            this.banner = res.air_index[0];
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    bannerAdv() {
      if (!this.banner.href) {
        return;
      }
      this.params(this.banner.href, this.banner.href, "bannerAdv");
    },
    //选择出发城市
    selectDeparture() {
      var str = this.departure.city + "," + this.departure.character;
      var result = new Array();
      result[0] = this.departure.city;
      result[1] = this.departure.character;
      this.params(result, str, "selectDeparture");
    },
    //选择到达城市
    selectDestination() {
      var str = this.destination.city + "," + this.destination.character;
      var result = new Array();
      result[0] = this.destination.city;
      result[1] = this.destination.character;
      this.params(result, str, "selectDestination");
    },
    change(item, index) {
      this.i = index;
      this.cabin = item;
    },
    goBack() {
      this.params("", "", "goBack");
    },
    commonProbem() {
      this.params("", "", "commonProbem");
    },
    // onClickRight() {
    //   this.$router.push({
    //     path: "/plane/problem",
    //     query: {
    //       module: 'air'
    //     }
    // 	});
    // },
    seleceSpace() {
      this.spacePop = !this.spacePop;
    },
    changeBy() {
      if (this.baby == true) {
        this.baby = false;
        this.baby_quantity = "0";
      } else {
        this.baby = true;
        this.baby_quantity = "1";
      }
    },
    changeCh() {
      if (this.child == true) {
        this.child = false;
        this.child_quantity = "0";
      } else {
        this.child = true;
        this.child_quantity = "1";
      }
    },
    childPopup() {
      this.childPop = !this.childPop;
    },
    changePlace() {
      //出发城市先存在placeSwitch
      this.placeSwitch = this.departure;
      //把到底城市赋给出发城市
      this.departure = this.destination;
      //把出发城市存在placeSwitch赋给到达城市
      this.destination = this.placeSwitch;
    },
    // 搜索
    search() {
      this.$router.push({
        path: "/select/list",
        query: {
          departure: this.departure.character,
          destination: this.destination.character,
          child_quantity: this.child_quantity,
          baby_quantity: this.baby_quantity,
          departure_date: this.departureDate.departure_,
          cabin: this.cabin.id,
          selected: this.selected,
          departure_city: this.departure.city,
          arrive_city: this.destination.city,
        },
      });
    },

    //进入日期选择页面
    enterDate() {
      this.$router.replace({
        //路由跳转
        path: "/plane/calendar",
        query: {
          departure: this.departure.character,
          destination: this.destination.character,
          child_quantity: this.child_quantity,
          departure_date: this.departureDate.departure_,
          cabin: this.cabin.id,
          from: 1, //表示来自首页
          departure_city: this.departure.city,
          arrive_city: this.destination.city,
        },
      });
    },
    //设置今天、明天、星期几
    getDateText(date) {
      date = format(date);
      let now = format(new Date()),
        day_time = 24 * 60 * 60 * 1000, //一天共有多少秒
        day_num = Math.floor((date.getTime() - now.getTime()) / day_time);
      //getTime() 方法可返回距 1970 年 1 月 1 日之间的毫秒数。
      /* 
        now.getTime()为当前时间与1970 年 1 月 1 日之间的毫秒数
        date.getTime()为传递过来的时间与1970 年 1 月 1 日之间的毫秒数
        */

      if (day_num == 0) {
        return "今天";
      } else if (day_num == 1) {
        //如果今天是29号，传递进来的是30号，那么date.getTime() - now.getTime()的毫秒数是大于一天的毫秒数的
        return "明天";
      } else {
        let dayMap = {
          0: "星期天",
          1: "星期一",
          2: "星期二",
          3: "星期三",
          4: "星期四",
          5: "星期五",
          6: "星期六",
        };
        return dayMap[date.getDay()];
      }

      function format(date) {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
      }
    },
    close() {
      this.spacePop = false;
    },
    orderList() {
      this.$router.push({
        path: "/plane/order/list",
        query: {
          token: this.$route.query.token,
        },
      });
    },
    collection() {
      this.$router.push({
        path: "/collection/list",
        query: {
          departure_date: this.tomorrow,
        },
      });
    },
  },
  mounted() {
    //更新出发城市和到达城市
    var departureInfo = { city: "杭州", character: "HGH" };
    var destinationInfo = { city: "重庆", character: "CKG" };
    this.departure =
      JSON.parse(sessionStorage.getItem("departureInfo")) || departureInfo;
    this.destination =
      JSON.parse(sessionStorage.getItem("destinationInfo")) || destinationInfo;
    //this.GetDateStr()
    //let now = new Date();
    let now = new Date().setDate(new Date().getDate() + 1);
    //刚进入机票首页this.$route.query.departureDate为undefined ,则select为now
    //初始化时间
    let departureDate_ = this.$route.query.departureDate_;
    if (departureDate_) {
      departureDate_ = Date.parse(
        (departureDate_ + " 00:00:00").toString().replace(/,/g, "/")
      );
    }
    let select = new Date(departureDate_ || now); //departureDate_为路由传递过来的时间参数，包括年月日，字符串。
    let select_ = new Date(now);
    this.departureDate = {
      date: select.getMonth() + 1 + "月" + select.getDate() + "日",
      text: this.getDateText(select), //调用getDateText得到返回值，并把时间select作为参数传给函数
      departure_:
        select.getFullYear() +
        "-" +
        (select.getMonth() + 1 < 10
          ? "0" + (select.getMonth() + 1)
          : select.getMonth() + 1) +
        "-" +
        (select.getDate() < 10 ? "0" + select.getDate() : select.getDate()),
    };

    this.tomorrow =
      select_.getFullYear() +
      "-" +
      (select_.getMonth() + 1 < 10
        ? "0" + (select_.getMonth() + 1)
        : select_.getMonth() + 1) +
      "-" +
      (select_.getDate() < 10 ? "0" + select_.getDate() : select_.getDate());
  },
};
</script>

<style lang="less">
.plane {
  &-home-page {
    height: 100%;
    background: #f2f2f2;
    .van-nav-bar {
      background: #f2f2f2;
      padding-top: 24px;
      position: relative;
      .van-nav-bar__title {
        font-size: 18px;
        color: #333;
      }
      .van-nav-bar__text {
        color: #333;
        font-size: 14px;
      }
      .van-icon-arrow-left:before {
        display: none;
      }
      .van-nav-bar__left {
        left: 11px;
        .van-icon {
          width: 17px;
          height: 15px;
          display: inline-block;
          background: url(../../assets/plane/reBack.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .isiOSX {
      padding-top: 44px;
    }
    .content {
      position: relative;
      .banner {
        width: 100%;
        min-height: 180px;
      }
      .Msg {
        padding: 0 11px;
        position: absolute;
        left: 0;
        bottom: -42px;
        .box {
          height: auto;
          background: #fff;
          border-radius: 10px;
          padding: 0 14px 17px;
          box-shadow: #e3e3e3 2px 0 4px;
          .area {
            color: #333;
            font-size: 18px;
            font-weight: 700;
            text-align: center;
            height: 49px;
            line-height: 49px;
            margin-bottom: 12px;
            border-bottom: solid 1px rgba(0, 0, 0, 0.05);
            img {
              width: 22px;
              padding: 13px;
            }
            .left {
              float: left;
              width: 96px;
              text-align: right;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .right {
              float: right;
              width: 96px;
              text-align: left;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
          .time {
            height: 37px;
            line-height: 37px;
            text-align: left;
            color: #333;
            font-size: 18px;
            font-weight: 700;
            margin-bottom: 11px;
            border-bottom: solid 1px rgba(0, 0, 0, 0.05);
            span {
              color: #999;
              font-size: 13px;
              font-weight: normal;
              margin-left: 3px;
            }
            img {
              width: 6px;
              float: right;
              margin-top: 13px;
            }
          }
          .space {
            height: 40px;
            /*line-height: 37px;*/
            text-align: left;
            color: #333;
            font-size: 18px;
            font-weight: 700;
            border-bottom: solid 1px rgba(0, 0, 0, 0.05);
            .right {
              font-size: 13px;
              font-weight: normal;
              float: right;
              width: 60px;
              img {
                width: 13px;
                margin-right: 9px;
                float: left;
                margin-top: 12px;
              }
              span {
                color: #999;
                display: block;
                font-size: 9px !important;
              }
            }
            .r_h {
              margin-right: 19px;
            }
            .r_r {
              width: 66px;
            }
          }
          .child {
            height: 13px;
            line-height: 13px;
            padding-top: 2px;
            padding-bottom: 4px;
            span {
              color: #666;
              float: right;
              font-size: 9px !important;
              img {
                width: 10px;
                margin-left: 4px;
              }
            }
          }
          .van-button {
            height: 34px;
            line-height: 34px;
            border-radius: 17px;
            border: none;
            color: #fff;
            font-size: 14px;
            background: -webkit-linear-gradient(
              #feac7a,
              #ed6161
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              #feac7a,
              #ed6161
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              #feac7a,
              #ed6161
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(#feac7a, #ed6161);
          }
          .van-button--large {
            opacity: 1;
          }
        }
      }
    }
    .van-tabbar {
      height: 49px;
      .van-tabbar-item {
        color: #333;
        font-size: 11px !important;
      }
    }
    .van-popup--bottom {
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
      height: 365px;
      .title {
        color: #333;
        font-size: 16px;
        text-align: center;
        height: 32px;
        line-height: 32px;
        margin-top: 6px;
        font-weight: 700;
      }
      .list {
        color: #333;
        font-size: 14px;
        padding: 0 11px;
        height: 46px;
        line-height: 46px;
        img {
          width: 14px;
          float: right;
          margin-top: 16px;
        }
      }
      .cancel {
        padding: 86px 11px 0;
        .van-button {
          height: 34px;
          line-height: 34px;
          border-radius: 17px;
          border: none;
          color: #fff;
          font-size: 14px;
          background: -webkit-linear-gradient(
            #feac7a,
            #ed6161
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            #feac7a,
            #ed6161
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            #feac7a,
            #ed6161
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(#feac7a, #ed6161);
        }
      }
    }
    .reserve {
      width: 100%;
      background: rgba(0, 0, 0, 0);
      padding-top: 11px;
      .explain-child {
        padding: 0 30px 0 33px;
        height: 449px;
        .explain-box {
          background: #fff;
          border-radius: 10px;
          padding: 0 10px;
          height: 100%;
          overflow-y: scroll;
          .title {
            color: #333;
            font-size: 14px;
            text-align: center;
            height: 52px;
            line-height: 52px;
            border-bottom: solid 1px #e3e3e3;
          }
          .explain-con {
            color: #333;
            font-size: 13px;
            padding: 18px 9px 41px 18px;
          }
          .top-con {
            padding-bottom: 0;
          }
        }
      }
      .close {
        width: 23px;
        position: absolute;
        top: 0px;
        right: 18px;
        z-index: 2009;
      }
    }
    .van-overlay {
      background-color: rgba(0, 0, 0, 0.5);
    }

    // .tipMSG {
    //   width: 80%;
    //   border-radius: 10px;
    //   .box {
    //     padding: 24px 20px 16px;
    //     .title {
    //       text-align: center;
    //       img {
    //         display: inline-block;
    //         width: 42px;
    //       }
    //     }
    //     .message {
    //       color: #333;
    //       font-size: 16px;
    //       line-height: 28px;
    //       text-align: left;
    //       margin: 16px 0 24px;
    //       span {
    //         color: #fe625a;
    //       }
    //     }
    //     .btn {
    //       width: 100%;
    //       line-height: 51px;
    //       color: #fe625a;
    //       font-size: 18px;
    //       text-align: center;
    //       background: #ffe2e0;
    //       display: inline-block;
    //       border-radius: 10px;
    //       margin-bottom: 8px;
    //     }
    //     .tip {
    //       line-height: 28px;
    //       color: #999;
    //       font-size: 14px;
    //       text-align: center;
    //       img {
    //         width: 15px;
    //         margin: 0 4px -3px 0;
    //         display: inine-block;
    //       }
    //     }
    //   }
    // }
  }
}
</style>
